"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakingDeposits = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const live_env_1 = require("@ledgerhq/live-env");
const getIndexerUrl = (route) => `${(0, live_env_1.getEnv)("API_NEAR_STAKING_POSITIONS_API")}${route || ""}`;
const getStakingDeposits = (address) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, network_1.default)({
        method: "GET",
        url: getIndexerUrl(`staking-deposits/${address}?date=${new Date().getTime()}`),
    });
    return Array.isArray(data) ? data : [];
});
exports.getStakingDeposits = getStakingDeposits;
//# sourceMappingURL=near-staking-positions-sdk.js.map